import React, { useEffect, useState } from 'react';
import { useScopedI18n } from '@locales/client';

import { useUser } from '@/shared/providers/user-provider/use-user';
import { Condition } from '@/shared/ui/condition';

import { useLoyaltyList } from '@/flat-pages/status/model/hooks';
import { ProgressBar, ProgressBarLabel } from '@/flat-pages/status/styles';
import {
  StatusCardStyle,
  ActiveBg,
  StatusCardContent,
  StatusCardCrown,
  StatusCardTitle,
  DetailField,
  DetailLabel,
  DetailValue,
} from './styles';

export const CROWN_IMAGE_URL = '/images/icons/status_new/status_level_';

type StatusCardT = {
  cardLevel: number;
};

export const StatusCard = ({ cardLevel }: StatusCardT) => {
  const { user } = useUser();
  const [cashback, setCashback] = useState(0);
  const [points, setPoints] = useState(0);
  const [currentLevel, setCurrentLevel] = useState(0);
  const [progressOfLevel, setProgressOfLevel] = useState(0);
  const [progress, setProgress] = useState(0);
  const [targetPoints, setTargetPoints] = useState(0);
  // const [currentLoyalty, setCurrentLoyalty] = useState(0);

  const { isError, loyaltyList, isLoading } = useLoyaltyList();

  const s = useScopedI18n('status');
  const st = useScopedI18n('status.status_name');

  useEffect(() => {
    if (!isLoading && !isError && loyaltyList) {
      let currentLevelIndex = loyaltyList.currentLevel - 1;

      setCashback(loyaltyList.levels[cardLevel].cashback);
      setPoints(loyaltyList.levels[cardLevel].points);

      if (user.isAuth) {
        // setCurrentLoyalty(loyaltyList.loyalty);
        setCurrentLevel(loyaltyList.currentLevel);
        if (currentLevelIndex < loyaltyList.levels.length - 2) {
          const progressLevel =
            loyaltyList.loyalty -
            loyaltyList.levels[currentLevelIndex].needLoyalty;
          setProgressOfLevel(progressLevel);
          const currentProgress =
            (100 * progressLevel) /
            (loyaltyList.levels[currentLevelIndex + 1].needLoyalty -
              loyaltyList.levels[currentLevelIndex].needLoyalty);
          setProgress(currentProgress);
        }
        const needLoyalty =
          loyaltyList.levels[
            currentLevelIndex < loyaltyList.levels.length - 2
              ? currentLevelIndex + 1
              : currentLevelIndex
          ].needLoyalty;
        setTargetPoints(needLoyalty);
      }
    } else if (isError) {
      console.warn(isError);
    }
  }, [isLoading, loyaltyList, cardLevel, isError, user.isAuth]);

  const matchLavel = {
    isActive: user.isAuth && cardLevel == currentLevel - 1,
    isCompleted:
      user.isAuth &&
      cardLevel == currentLevel &&
      loyaltyList != undefined &&
      !isError &&
      !isLoading,
  };

  return (
    <StatusCardStyle $level={cardLevel}>
      <Condition match={matchLavel.isActive}>
        <ActiveBg $level={cardLevel} />
      </Condition>
      <StatusCardContent>
        <StatusCardTitle $isActive={matchLavel.isActive}>
          <StatusCardCrown
            data-image-url={`${CROWN_IMAGE_URL}${cardLevel}.svg`}
          ></StatusCardCrown>
          {st(cardLevel)}
        </StatusCardTitle>
        <Condition match={matchLavel.isCompleted}>
          <ProgressBar $progress={progress}>
            <ProgressBarLabel>
              {s('progress_value', {
                value: Math.trunc(progressOfLevel),
                total: targetPoints,
              })}
            </ProgressBarLabel>
          </ProgressBar>
        </Condition>
      </StatusCardContent>
      <DetailField $isActive={matchLavel.isActive}>
        <DetailLabel>{s('points')}</DetailLabel>
        <DetailValue>×{points}</DetailValue>
      </DetailField>
      <DetailField $isActive={matchLavel.isActive}>
        <DetailLabel>{s('cashback')}</DetailLabel>
        <DetailValue>{cashback}%</DetailValue>
      </DetailField>
    </StatusCardStyle>
  );
};
